<template>
  <div
    class="color-selector__color-box"
    :class="{ 'is-selected': currentVariantId === variant.id }"
    :key="variant.id"
    @click.prevent="selectColor($event, variant.id)"
  >
    <div
      class="color-selector__color color-selector__color--primary"
      :style="`background-color: ${variant.colorCodePrimary}`"
    ></div>
    <div
      class="color-selector__color color-selector__color--secondary"
      :style="`background-color: ${variant.colorCodeSecondary}`"
    ></div>
  </div>
</template>

<script>
import settings from '../../../FilterPage/filter-settings.js'
import getPageContext from '@/helpers/page-context'

export default {
  name: 'ColorBox',

  props: {
    variant: {
      type: Object,
      required: true,
    },
    currentVariantId: {
      type: Number,
      required: true,
    },
    onColorSelect: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      maleVariants: [],
      femaleVariants: [],
    }
  },

  methods: {
    animateVariantImageChange() {
      document.body.classList.remove(settings.transitionClass)
      this.$nextTick(function() {
        document.body.classList.add(settings.transitionClass)
      })
    },

    selectColor($event) {
      this.animateVariantImageChange()
      this.onColorSelect(this.variant.id)
      On.Analytics.trackColorSelect(this.variant.spreeProduct, getPageContext($event))
    },
  },
}
</script>
